export const PREFERRED_PAYMENT_METADATA_KEY = 'add_preferred_payment_method';
export const PREFERRED_PAYMENT_ENABLED = false;